var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.577 1.647a1.914 1.914 0 0 0 2.845 0l.925-1.015a1.916 1.916 0 0 1 3.336 1.382l-.07 1.37a1.916 1.916 0 0 0 2.007 2.01l1.37-.07a1.916 1.916 0 0 1 1.378 3.336l-1.019.92a1.918 1.918 0 0 0 0 2.846l1.02.92a1.917 1.917 0 0 1-1.383 3.336l-1.37-.07a1.915 1.915 0 0 0-2.01 2.012l.069 1.37a1.917 1.917 0 0 1-3.328 1.38l-.92-1.02a1.916 1.916 0 0 0-2.845 0l-.925 1.02a1.916 1.916 0 0 1-3.331-1.378l.07-1.37a1.916 1.916 0 0 0-2.011-2.012l-1.37.07A1.915 1.915 0 0 1 .63 13.35l1.018-.92a1.918 1.918 0 0 0 0-2.845L.63 8.66a1.916 1.916 0 0 1 1.378-3.332l1.37.07A1.915 1.915 0 0 0 5.39 3.381l-.065-1.37A1.917 1.917 0 0 1 8.657.631l.92 1.015z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.999,
    cy: 11.003,
    rx: 4.402,
    ry: 4.403
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.5932ea48.svg";
export { ForwardRef as ReactComponent };